import React from "react";
import { NavLink } from "react-router-dom"; // Changed from Link to NavLink
import "./Header.css";

const Header = () => {
  return (
    <header className="header">
      <div className="title">
        <NavLink to="/" className="title-link">
          Prof. (Dr) Mallikarjuna Rao Dubisetty
        </NavLink>
      </div>
      <nav className="nav">
        <NavLink to="/" end>
          Home
        </NavLink>
        <NavLink to="/magazines">
          Magazines
        </NavLink>
        <NavLink to="/blogs">
          Blogs
        </NavLink>
        <NavLink to="/about">
          About Me
        </NavLink>
      </nav>
    </header>
  );
};

export default Header;